
const _colors = {
  White: '#F2F2F2',
  LightGray: '#C4C4C4',
  Blue: '#2D9CDB',
  Brown: '#6A414B',
  DarkBlue: '#1E5C80',
  Red: '#EB5757',
  LightBrown: '#7F444E',
  LightDarkBlue: '#20678F',
  Gray: '#828282',
  MouseGray: '#BDBDBD',
  DarkGray: '#4F4F4F',
  Black: '#09151C',
  BlueBlack: '#112935',
  OceanBlue: '#316E91',
  SkyBlue: '#2F8CC2',
  LightGreen: '#78FACE',
  BlueGray: '#263C47',
  DarkYellowGreen: '#428778',
  LemonYellow: '#F9FE0C',
  Purple: '#D03EDD',
  DarkBlueBlack: '#081E29',
  Navy: '#346C88',
  LightNavy: '#779EB8',
  DarkNavy: '#6A90AA',
  DeepDarkNavy: '#46667B',
  Orange: '#FF2406',
  Green: '#0BB508',
  Yellow: '#E9ED17',
  Pink: '#ED177E',
  DeepNavy: '#21526D',
  MandarinOrange: '#5EC8B1',
  RedBrown: '#BF565D',
  DeepBlueNavy: '#125273'
}

export default {
  data() {
    return {
      sdfColor: _colors,
    };
  },
  methods: {}
};
